import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

interface TeamAnalysis {
  id: number;
  query: string;
  deep_mode: boolean;
  created_by: number;
}

const getTeamAnalyses = async (): Promise<TeamAnalysis[]> => {
  const response = await instance.get('/nexa/analysis-templates/team');
  return response.data;
};

export const useGetTeamAnalyses = () => {
  return useQuery({
    queryKey: ['team-analyses'],
    queryFn: getTeamAnalyses,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
